// import React from "react";
// import PropTypes from "prop-types";

// const propTypes = { name: PropTypes.string };

// const defaultProps = { name: "" };

// const Icon = ({ name }) => {

//   return <span className={`icon-${name}`} />;
// };

// Icon.propTypes = propTypes;
// Icon.defaultProps = defaultProps;

// export default Icon;

import React from "react";
import cx from "classnames";
import "./index.scss";

const Icon = ({ name, color, size, className, onClick }) => {
  const onClickIcon = () => {
    if (typeof onClick === "function") {
      onClick();
    }
  };

  return (
    <span
      onClick={onClickIcon}
      className={cx({
        [`icon-${name}`]: !!name,
        [className]: !!className,
      })}
      style={{
        color,
        fontSize: size,
        cursor: typeof onClick === "function" && "pointer",
      }}
    >
      {Array(10)
        .fill()
        .map((_, index) => (
          <span
            key={index}
            style={{ color }}
            className={cx({
              [`path${index + 1}`]: true,
              hasBefore: true,
              [color]: !!color,
            })}
          />
        ))}
    </span>
  );
};

export default Icon;
